export default "__VITE_ASSET__CoL3IY7z__"